import { SERVICE_FRAGMENT } from '../@shared-fragments/serviceFragment';
import { mapService } from '../@shared-mappers/mapService';
import { useLoadBoardServicesQuery } from '../queries/useLoadBoardServicesQuery';

import { createMutationHook } from '~/shared/providers/api';

export const useServiceUnassignMutation = createMutationHook(
  'transportation.serviceUnassign',
  (params: { id: string }) => ({
    transportationServiceUnassign: {
      __args: {
        id: params.id,
      },
      ...SERVICE_FRAGMENT,
    },
  }),
  {
    select: ({ transportationServiceUnassign: service }) => mapService(service),
    invalidateQueries: [useLoadBoardServicesQuery],
  },
);
